import React from 'react';
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png"
import DefaultLayoutProps from '../interfaces/DefaultLayoutProps';

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ children, withoutMenu = false }) => {
    return (
        <>
            <header>
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                    <div className="container-fluid">                        
                        <Link className="navbar-brand" to="/">
                            <img src={logo} alt="Logo" width="50" />&nbsp;AMEOS Security Console
                        </Link>

                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        {!withoutMenu && <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav ms-auto">
                                <li className="nav-item">
                                    <Link className="nav-link" to="/projects">Projets</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/customers">Clients</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link" to="/logout">Déconnexion</Link>
                                </li>
                            </ul>
                        </div>}
                    </div>
                </nav>
            </header>            
            <main className="mt-4 mb-4">
                <div className="container">
                    {children}
                </div>
            </main>
            
            <footer className="container-fluid mt-5 bg-light">
                <div className="col-12 p-4">
                <p className="text-dark m-0">&copy; 2025 AMEOS</p>
                </div>
            </footer>
        </>
    );
}

export default DefaultLayout;